/**
 * PREMISSA DO PROJETO — fotos de imóvel
 * ---------------------------------
 * 1. Persistência: POST http://{API}/api/upload + POST /api/property-photos (Nest).
 * 2. Leitura: GET http://{API}/api/media/properties/:propertyId/:filename
 * 3. O container/site (nginx :3000) NÃO grava arquivos de imóvel.
 * 4. Em edição (propertyId conhecido), upload é IMEDIATO ao selecionar o arquivo.
 */
import { getPropertyImageUrl } from '@/config/api';
import { PropertyPhotoService } from '@/services/propertyPhotoService';

export type PersistedPropertyPhoto = {
  id: number;
  url: string;
  legenda: string;
  filename: string;
};

/** Envia arquivo para a API e retorna dados para exibir na UI (URL da API, nunca blob). */
export async function persistPropertyPhotoToApi(
  propertyId: number,
  file: File,
  legenda = '',
): Promise<PersistedPropertyPhoto> {
  const uploaded = await PropertyPhotoService.uploadPhoto(propertyId, file, legenda);
  return {
    id: uploaded.id,
    filename: uploaded.filename,
    legenda: uploaded.caption || legenda,
    url: getPropertyImageUrl(propertyId, uploaded.filename),
  };
}
